import { render } from "./BaseMap.vue?vue&type=template&id=2084f994&scoped=true"
import script from "./BaseMap.vue?vue&type=script&lang=js"
export * from "./BaseMap.vue?vue&type=script&lang=js"

import "./BaseMap.vue?vue&type=style&index=0&id=2084f994&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2084f994"]])

export default __exports__